export class GuestCompanion {
    name = ''
    normal = true
    vegan = false
    vegitarien = false
    allergien = false
    allergien_name = ''
}